import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { PropType } from 'vue'
import { computed } from 'vue'

type CardRadius = 'regular' | 'smooth' | 'rounded'
type CardColor =
  | undefined
  | 'primary'
  | 'secondary'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'


export default /*@__PURE__*/_defineComponent({
  __name: 'VCard',
  props: {
  radius: {
    type: String as PropType<CardRadius>,
    default: 'regular',
    validator: (value: CardRadius) => {
      // The value must match one of these strings
      if (['regular', 'smooth', 'rounded'].indexOf(value) === -1) {
        console.warn(
          `V-Card: invalid "${value}" radius. Should be smooth, rounded or regular`
        )
        return false
      }

      return true
    },
  },
  color: {
    type: String as PropType<CardColor>,
    default: undefined,
    validator: (value: CardRadius) => {
      // The value must match one of these strings
      if (
        [
          undefined,
          'primary',
          'secondary',
          'info',
          'success',
          'warning',
          'danger',
        ].indexOf(value) === -1
      ) {
        console.warn(
          `V-Card: invalid "${value}" color. Should be primary, secondary, info, 
          success, warning, danger or undefined`
        )
        return false
      }

      return true
    },
  },
  elevated: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const cardRadius = computed(() => {
  if (props.radius === 'smooth') {
    return 's-card'
  } else if (props.radius === 'rounded') {
    return 'l-card'
  }

  return 'r-card'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      cardRadius.value,
      __props.elevated && 'is-raised',
      props.color && `is-${props.color}`,
    ])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})